// Incentit IQ Branding Configuration
export const brandingConfig = {
  // Application Identity
  appName: 'Incentit IQ',
  appTagline: 'Advanced Reporting & Analytics',
  companyName: 'Incentit',
  
  // Visual Assets
  logo: {
    main: '/logo.png',
    favicon: '/favicon.png',
    alt: 'Incentit IQ Logo'
  },
  
  // Color Scheme - Incentit Brand Colors
  colors: {
    primary: '#F26A2E',        // Orange - Primary buttons and CTAs
    primaryDark: '#E55A1E',    // Darker orange for hover states
    secondary: '#2F6FA3',      // Blue - Secondary buttons
    secondaryDark: '#265A8A',  // Darker blue for hover states
    accent: '#38b2ac',         // Teal accent (keeping for success states)
    success: '#48bb78',        // Green for success states
    warning: '#ed8936',        // Orange for warnings
    error: '#f56565',          // Red for errors
    info: '#2F6FA3',           // Blue for info (matches secondary)
    
    // Brand-specific neutral colors
    background: '#F7F9FB',     // Light Gray background
    surface: '#FFFFFF',        // White card backgrounds
    border: '#E3E8EE',         // Light Gray borders/dividers
    text: '#4A5560',           // Dark Gray header text
    textSecondary: '#5F6B75'   // Medium Gray body text
  },
  
  // Typography
  fonts: {
    primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
  },
  
  // Layout
  layout: {
    headerHeight: '64px',
    sidebarWidth: '250px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  
  // Meta Information
  meta: {
    description: 'Incentit IQ - Advanced Reporting and Analytics Platform for data-driven insights',
    keywords: 'reporting, analytics, business intelligence, data visualization, incentit',
    author: 'Incentit',
    version: '1.0.0'
  },
  
  // Feature Flags
  features: {
    darkMode: false, // Future enhancement
    customThemes: false, // Future enhancement
    tenantBranding: false // Future enhancement
  }
}

// CSS Custom Properties for theming
export const cssVariables = {
  '--brand-primary': brandingConfig.colors.primary,
  '--brand-primary-dark': brandingConfig.colors.primaryDark,
  '--brand-secondary': brandingConfig.colors.secondary,
  '--brand-secondary-dark': brandingConfig.colors.secondaryDark,
  '--brand-accent': brandingConfig.colors.accent,
  '--brand-success': brandingConfig.colors.success,
  '--brand-warning': brandingConfig.colors.warning,
  '--brand-error': brandingConfig.colors.error,
  '--brand-info': brandingConfig.colors.info,
  '--brand-background': brandingConfig.colors.background,
  '--brand-surface': brandingConfig.colors.surface,
  '--brand-border': brandingConfig.colors.border,
  '--brand-text': brandingConfig.colors.text,
  '--brand-text-secondary': brandingConfig.colors.textSecondary,
  '--brand-font-primary': brandingConfig.fonts.primary,
  '--brand-font-mono': brandingConfig.fonts.mono,
  '--brand-header-height': brandingConfig.layout.headerHeight,
  '--brand-sidebar-width': brandingConfig.layout.sidebarWidth,
  '--brand-border-radius': brandingConfig.layout.borderRadius,
  '--brand-box-shadow': brandingConfig.layout.boxShadow
}

// Helper function to apply branding to document
export function applyBranding() {
  // Update document title
  document.title = `${brandingConfig.appName} - ${brandingConfig.appTagline}`
  
  // Update meta tags
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.setAttribute('content', brandingConfig.meta.description)
  }
  
  const metaKeywords = document.querySelector('meta[name="keywords"]')
  if (metaKeywords) {
    metaKeywords.setAttribute('content', brandingConfig.meta.keywords)
  }
  
  // Apply CSS variables to root element
  const root = document.documentElement
  Object.entries(cssVariables).forEach(([property, value]) => {
    root.style.setProperty(property, value)
  })
}

export default brandingConfig
